import * as React from 'react';
import { createContext, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import api from '../api.js';
import { AutostahlLocation, Make } from '../../types';

const LocationMakeContext = createContext<{ locations: AutostahlLocation[]; makes: Make[] } | undefined>(undefined);

export const ServiceBookingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { t, i18n } = useTranslation();
    const [locations, setLocations] = useState<AutostahlLocation[]>([]);
    const [makes, setMakes] = useState<Make[]>([]);

    const fetchAll = async () => {
        try {
            const [locRes, makesRes] = await Promise.all([api.getLocations(i18n.language), api.getMakes()]);
            setLocations(locRes);
            setMakes(makesRes);
        } catch (e) {
            alert(t('error.requiredDataFailed'));
            console.error('Failed to load data:', e);
        }
    };

    useEffect(() => {
        fetchAll().then();
    }, []);

    return <LocationMakeContext.Provider value={{ locations, makes }}>{children}</LocationMakeContext.Provider>;
};

export const useServiceBookingState = () => {
    const ctx = useContext(LocationMakeContext);
    if (!ctx) throw new Error('useLocationMakes must be used within LocationMakeProvider');
    return ctx;
};
